import { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import emailjs from 'emailjs-com';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { transition1 } from '../transitions';

// الصور
import QrCode from '../assets/img/VisKar QR Youka GmbH scan or click me neu.png';
import DSGVO from '../assets/img/DSGVO.png';
import Deutscheserver from '../assets/img/Deutsche server.png';
import SSL from '../assets/img/SSL verschl.png';

// الأيقونات
import { LuPhone } from "react-icons/lu";
import { MdOutlineMail } from "react-icons/md";
import { GrLocation } from "react-icons/gr";
import { CgWebsite } from "react-icons/cg";
import { FiClock } from "react-icons/fi";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaYoutube,
  FaStar,
} from 'react-icons/fa6';
import { SiGooglemybusiness } from 'react-icons/si';

const Kontakt = () => {
  const form = useRef();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [datenschutzZustimmung, setDatenschutzZustimmung] = useState(false);
  const [username, setUsername] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [nachricht, setNachricht] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [userEmailError, setUserEmailError] = useState('');

  // 🔹 ساعات الدوام
  const [isOpen, setIsOpen] = useState(false);
  const [todayText, setTodayText] = useState('');
  const [showAll, setShowAll] = useState(false);

  const handleImageClick = () => navigate('/VisKar');

  const handleCall = () => window.location.href = 'tel:+49 (0) 30 85968082';
  const handleFax = () => window.location.href = 'fax:+49 (0) 30 85968082';
  const handleEmail = () => window.location.href = 'mailto:info@youka-gmbh.com';
  const redirectToWebsite = () => window.location.href = 'https://youka-gmbh.com';
  const handleMap = () => window.open('https://www.google.com/maps/place/Rungestr.+13,+10179+Berlin', '_blank');

  const validateName = (name) => /^[a-zA-Z\s]+$/.test(name);
  const validateEmail = (email) => /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}/g.test(email);

  const handleBlurName = () => setUsernameError(validateName(username) ? '' : 'Name darf nur Buchstaben enthalten.');
  const handleBlurEmail = () => setUserEmailError(validateEmail(userEmail) ? '' : 'Bitte geben Sie eine gültige E-Mail-Adresse ein.');

  const sendEmail = async (e) => {
    e.preventDefault();
    if (!validateName(username) || !validateEmail(userEmail)) return;

    setIsLoading(true);
    try {
      await emailjs.sendForm('service_7ia9w8d', 'template_5849kxh', form.current, '1Vq41rr-oyTR0PF3j');
      toast.success("Nachricht wurde erfolgreich versendet");
      setUsername('');
      setUserEmail('');
      setNachricht('');
      setDatenschutzZustimmung(false);
      e.target.reset();
    } catch (error) {
      toast.error("Fehler beim Senden der Nachricht!");
    } finally {
      setIsLoading(false);
    }
  };

  // 🕒 منطق حساب ساعات الدوام
  const officeHours = [
    { day: "Montag", open: "09:00", close: "17:00" },
    { day: "Dienstag", open: "09:00", close: "17:00" },
    { day: "Mittwoch", open: "09:00", close: "17:00" },
    { day: "Donnerstag", open: "09:00", close: "17:00" },
    { day: "Freitag", open: "09:00", close: "15:00" },
    { day: "Samstag", open: "Geschlossen", close: "" },
    { day: "Sonntag", open: "Geschlossen", close: "" },
  ];

  useEffect(() => {
    const todayIndex = new Date().getDay(); // 0=الأحد
    const adjustedIndex = todayIndex === 0 ? 6 : todayIndex - 1;
    const today = officeHours[adjustedIndex];
    const now = new Date();
    const [h, m] = [now.getHours(), now.getMinutes()];
    const nowStr = `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;

    let openNow = false;
    if (today.open !== "Geschlossen") {
      openNow = nowStr >= today.open && nowStr <= today.close;
    }

    setIsOpen(openNow);
    setTodayText(
      `Heute (${today.day}): ${
        today.open === "Geschlossen"
          ? "Geschlossen"
          : `${today.open} – ${today.close} Uhr`
      }`
    );
  }, []);

  return (
    <div className="relative flex flex-col min-h-screen bg-white">
      <motion.section
        initial={{ opacity: 0, y: '-100%' }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: '100%' }}
        transition={transition1}
      >
        <div className="container mx-auto mt-20 px-4 py-20 text-[#103d5b]">
          
          {/* العنوان */}
          <div className="text-center mb-14">
            <h1 className="h1 mb-4 text-5xl font-bold">Kontaktieren Sie uns</h1>
            <p className="text-lg max-w-2xl mx-auto">
              Wir freuen uns auf Ihre Anfrage! Füllen Sie bitte das Formular aus, um uns eine Nachricht zu senden.
              Unser Team wird sich so schnell wie möglich bei Ihnen melden.
            </p>
          </div>

          {/* نموذج الاتصال */}
          <form ref={form} onSubmit={sendEmail} className="max-w-3xl mx-auto text-xs font-secondary mb-20">
            <div className="lg:flex gap-x-5 mb-4">
              <div className="w-full">
                <input
                  className="outline-none border-b border-b-primary h-[35px] bg-transparent w-full pl-2 placeholder:text-[#4a5051]"
                  required
                  type="text"
                  name="username"
                  placeholder="Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onBlur={handleBlurName}
                />
                {usernameError && <div className="text-red-500 text-xs mt-1">{usernameError}</div>}
              </div>

              <div className="w-full mt-4 lg:mt-0">
                <input
                  className="outline-none border-b border-b-primary h-[35px] bg-transparent w-full pl-2 placeholder:text-[#4a5051]"
                  required
                  type="email"
                  name="userEmail"
                  placeholder="E-Mail-Adresse"
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  onBlur={handleBlurEmail}
                />
                {userEmailError && <div className="text-red-500 text-xs mt-1">{userEmailError}</div>}
              </div>
            </div>

            <textarea
              className="outline-none border-b border-b-primary bg-transparent w-full pl-2 pt-2 placeholder:text-[#4a5051]"
              required
              name="nachricht"
              placeholder="Nachricht"
              value={nachricht}
              onChange={(e) => setNachricht(e.target.value)}
            />

            <label className="flex items-center mt-4 text-sm">
              <input
                type="checkbox"
                required
                className="mr-2"
                checked={datenschutzZustimmung}
                onChange={(e) => setDatenschutzZustimmung(e.target.checked)}
              />
              Ich stimme dem
              <a href="./impressum" className="checkbox ml-1 text-blue-600 hover:underline"> Impressum</a> und
              <a href="./datenschutz" className="checkbox ml-1 text-blue-600 hover:underline"> Datenschutz</a> zu.
            </label>

            <button
              type="submit"
              disabled={isLoading || !datenschutzZustimmung}
              className="btnHome mt-6"
            >
              {isLoading ? "Wird gesendet..." : "Senden"}
            </button>
          </form>

          {/* أيقونات الأمان */}
          <div className="flex justify-center items-center gap-10 mb-20 mt-4 opacity-90">
            <img src={SSL} alt="SSL Verschlüsselung" className="h-10 w-auto object-contain" />
            <img src={Deutscheserver} alt="Deutscher Server" className="h-10 w-auto object-contain" />
            <img src={DSGVO} alt="DSGVO Konform" className="h-10 w-auto object-contain" />
          </div>

          {/* QR-Code */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-10 mb-20">
            <div className="max-w-md text-center md:text-left">
              <h2 className="text-2xl font-semibold ">Digitale Visitenkarte</h2>
              <p className="text-lg leading-relaxed">
                Scannen oder klicken Sie auf den QR-Code, um unsere digitale Visitenkarte zu öffnen.
                Sie können unsere Kontaktdaten direkt auf Ihrem Smartphone speichern.
              </p>
            </div>
            <img
              src={QrCode}
              alt="Digitale Visitenkarte"
              className="w-56 h-auto mt-4 cursor-pointer"
              onClick={handleImageClick}
            />
          </div>

          {/* بيانات الاتصال */}
          <div className="text-center md:text-left max-w-2xl mx-auto mb-10">
            <h2 className="text-3xl font-semibold mb-6 text-center">Kontaktdaten</h2>
            <ul className="text-[#103d5b] font-semibold text-lg space-y-4">
              <li onClick={handleCall} className="cursor-pointer flex items-center justify-center md:justify-start gap-3 border-b border-gray-300 pb-3"><LuPhone /> +49 (0) 30 85968082</li>
              <li onClick={handleFax} className="cursor-pointer flex items-center justify-center md:justify-start gap-3 border-b border-gray-300 pb-3"><LuPhone /> Fax: +49 (0) 30 85968083</li>
              <li onClick={handleEmail} className="cursor-pointer flex items-center justify-center md:justify-start gap-3 border-b border-gray-300 pb-3"><MdOutlineMail /> info@youka-gmbh.com</li>
              <li onClick={redirectToWebsite} className="cursor-pointer flex items-center justify-center md:justify-start gap-3 border-b border-gray-300 pb-3"><CgWebsite /> www.youka-gmbh.com</li>
              <li onClick={handleMap} className="cursor-pointer flex items-center justify-center md:justify-start gap-3 border-b border-gray-300 pb-3"><GrLocation /> Rungestr. 13, 10179 Berlin</li>
            </ul>
          </div>

          {/* ساعات العمل */}
          <div className="text-center md:text-left max-w-2xl mx-auto mb-16">
            <h2 className="text-3xl font-semibold mb-6 text-center">Öffnungszeiten</h2>
            <ul className="text-[#103d5b] font-semibold text-lg space-y-4">
              <li className="flex items-center justify-center md:justify-start gap-3 border-b border-gray-300 pb-3">
                <FiClock />
                {todayText}{" "}
                <span className={`${isOpen ? 'text-green-600' : 'text-red-600'} font-semibold`}>
                  ({isOpen ? "Jetzt geöffnet" : "Jetzt geschlossen"})
                </span>
              </li>

              {showAll && officeHours.map((d, i) => (
                <li key={i} className="flex items-center justify-center md:justify-start gap-3 border-b border-gray-300 pb-3">
                  <FiClock />
                  {d.day}: {d.open === "Geschlossen" ? <span className="text-red-600">Geschlossen</span> : `${d.open} – ${d.close} Uhr`}
                </li>
              ))}
            </ul>

            <button
              onClick={() => setShowAll(!showAll)}
              className="mt-3 text-sm text-[#10a5c7] hover:underline flex items-center justify-center md:justify-start gap-1"
            >
              {showAll ? "Weniger anzeigen ⬆️" : "Weitere Tage anzeigen ⬇️"}
            </button>
          </div>

          {/* السوشيال ميديا */}
          <div className="flex flex-wrap justify-center gap-6 text-3xl text-[#103d5b] mb-16">
            <a href="https://www.facebook.com/youkagmbh" target="_blank" rel="noopener noreferrer"><FaFacebookF className="hover:text-blue-600 transition-colors" /></a>
            <a href="https://www.instagram.com/youkagmbh" target="_blank" rel="noopener noreferrer"><FaInstagram className="hover:text-pink-600 transition-colors" /></a>
            <a href="https://www.tiktok.com/@youkagmbh" target="_blank" rel="noopener noreferrer"><FaTiktok className="hover:text-black transition-colors" /></a>
            <a href="https://wa.me/491604035965" target="_blank" rel="noopener noreferrer"><FaWhatsapp className="hover:text-green-600 transition-colors" /></a>
            <a href="https://www.youtube.com/@youkagmbh" target="_blank" rel="noopener noreferrer"><FaYoutube className="hover:text-red-600 transition-colors" /></a>
            <a href="https://share.google/mOe0aR4AdyHDlkLxr" target="_blank" rel="noopener noreferrer"><SiGooglemybusiness className="hover:text-blue-400 transition-colors" /></a>
            <a href="https://search.google.com/local/writereview?placeid=ChIJscuryPlYPAwRUrn4oiEFTMw" target="_blank" rel="noopener noreferrer"><FaStar className="hover:text-yellow-500 transition-colors" /></a>
          </div>

          {/* خريطة Google */}
          <div className="w-full max-w-5xl mx-auto rounded-2xl overflow-hidden shadow-2xl border border-gray-200">
            <iframe
              width="100%"
              height="450"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=de&amp;q=Rungestr.13+(Youka-GmbH)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              title="Google Map"
            ></iframe>
          </div>
        </div>

        <ToastContainer className="text-xs w-64 mt-32 left-1" />
      </motion.section>
    </div>
  );
};

export default Kontakt;
